export default function TutionReport({ fill, width, height }) {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 22 23"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.25 20.5C16.3586 20.5 20.5 16.3586 20.5 11.25C20.5 6.14137 16.3586 2 11.25 2C6.14137 2 2 6.14137 2 11.25C2 16.3586 6.14137 20.5 11.25 20.5ZM11.25 22.5C17.4632 22.5 22.5 17.4632 22.5 11.25C22.5 5.0368 17.4632 0 11.25 0C5.0368 0 0 5.0368 0 11.25C0 17.4632 5.0368 22.5 11.25 22.5ZM12.0608 5.12963C11.6763 4.97649 11.2812 4.96397 10.8814 5.06606C10.2897 5.21631 10.0016 5.5823 10.0006 6.19003C9.99999 6.83404 10.0002 7.47805 10.0004 8.12207L10.0006 9.08808C10.0006 9.37429 10.0005 9.66049 10.0003 9.9467V9.94753C9.99992 10.6627 9.99953 11.3779 10.0016 12.093C10.0035 12.6035 10.229 12.9233 10.7031 13.1101C11.0249 13.2372 11.3564 13.2671 11.6937 13.2054C12.4559 13.0668 12.7613 12.6979 12.7613 11.9274V8.04213C12.7613 7.86211 12.7615 7.68218 12.7616 7.50228C12.762 7.05269 12.7624 6.60331 12.7604 6.15343C12.7584 5.65453 12.5262 5.31551 12.0608 5.12963ZM10.0093 15.9793C10.0103 15.2271 10.6492 14.5972 11.3979 14.6088C12.1447 14.6213 12.7604 15.2483 12.7527 15.9909C12.744 16.7363 12.1167 17.3576 11.3757 17.3518C10.6309 17.346 10.0074 16.72 10.0093 15.9793Z"
        />
      </svg>
    )
  }
  